import * as React from 'react';
import { ComponentClass, SFC } from 'react';

export interface MediaProps {
  query: string;
  render?: () => React.ReactNode;
  matchByDefault?: boolean;
}

export interface MediaState {
  matches: boolean;
}

export class Media extends React.Component<MediaProps, MediaState> {
  private mediaQueryList: MediaQueryList;

  constructor(props: MediaProps) {
    super(props);

    this.state = {
      matches: props.matchByDefault || false
    };
  }

  updateMatches = () =>
    this.setState({
      matches: this.mediaQueryList.matches
    });

  UNSAFE_componentWillMount() {
    if (typeof window.matchMedia !== 'function') {
      // matchMedia not supported ;_;
      return;
    }

    const { query } = this.props;

    this.mediaQueryList = window.matchMedia(query);

    this.mediaQueryList.addListener(this.updateMatches);

    this.updateMatches();
  }

  componentWillUnmount() {
    this.mediaQueryList.removeListener(this.updateMatches);
  }

  render() {
    const { children, render } = this.props;
    const { matches } = this.state;

    return render
      ? matches
        ? render()
        : null
      : children
      ? this.renderChildren(children, matches)
      : null;
  }

  private renderChildren = (
    children: React.ReactNode,
    matches: boolean
  ): React.ReactNode => {
    return typeof children === 'function'
      ? (children as Function)(matches)
      : !Array.isArray(children) || children.length // Preact defaults to empty children array
      ? matches
        ? React.Children.only(children)
        : null
      : null;
  };
}

/* tslint:disable:no-any */
export interface MediaIfProps {
  query: string;
  tag?: ComponentClass | SFC<any> | keyof JSX.IntrinsicElements;
  /* Allow any arbitrary additional props */
  [key: string]: any;
}
/* tslint:enable:no-any */

/*
  Wrap react-media to leverage it's "never render if not matched" behaviour,
  without explicitly having to pass a render function (which is pretty clunky).
*/
export const MediaIf: SFC<MediaIfProps> = props => {
  const Tag = props.tag || 'div';

  return (
    <Media
      query={props.query}
      render={() => <Tag {...props}>{props.children}</Tag>}
    />
  );
};

export const MEDIA_QUERY_DEFAULT = `(min-width: 781px)`;
export const MEDIA_QUERY_MOBILE = `(max-width: 838px)`;
export const MEDIA_QUERY_TABLET = `(min-width: 839px) and (max-width: 1090px)`;
export const MEDIA_QUERY_DESKTOP = `(min-width: 1091px)`;

/*
  Export a bunch of predefined responsive wrappers.
*/
export const Default: SFC = props => (
  <MediaIf {...props} query={MEDIA_QUERY_DEFAULT} />
);
export const Mobile: SFC = props => (
  <MediaIf {...props} query={MEDIA_QUERY_MOBILE} />
);
export const Tablet: SFC = props => (
  <MediaIf {...props} query={MEDIA_QUERY_TABLET} />
);
export const Desktop: SFC = props => (
  <MediaIf {...props} query={MEDIA_QUERY_DESKTOP} />
);



// WEBPACK FOOTER //
// ./src/app/components/Utils/Responsive/index.tsx